import styled from 'styled-components';
import { COLORS } from '@/theme';
import { Button } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledMainTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem 2rem 0;
`;

export const StyledPageTitle = styled.div`
  font-size: 1.75rem;
  font-weight: 700;
  color: ${COLORS.BLACK};
`;

export const StyledTabTitleWrapper = styled.div`
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem 2rem;
`;

export const StyledFormBlock = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 32rem;
  padding: 1.5rem 2rem;
  gap: 1rem;
`;

export const StyledSectionSubtitle = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${COLORS.BLACK};
  margin-top: 0.5rem;
`;

export const StyledCreateButton = styled(Button)`
  &&& {
    max-width: 18rem;
    height: 2.75rem;

    svg {
      fill: ${COLORS.BLACK};
    }
  }
`;

export const StyledActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
`;
